<script type="ts">
    import { v4 as uuidv4 } from 'uuid';

    let id: string = uuidv4();
    export let text: string;
    export let value = '';
    export let required = false;
    export let isValid = false;

    let validated = false;
    let validationMessage = '';

    function validate()
    {
        validated = true;
        isValid = true;
        validationMessage = '';

        if (required)
        {
            if (value === '')
            {
                isValid = false;
                validationMessage = 'Ce champ est obligatoire.';
                return;
            }
        }
        else if (value === '')
        {
            return;
        }

        isValid = true;
        validationMessage = '';
    }
</script>

<style>
    .errorMessage
    {
        color: red;
    }
</style>

<div class="form-group">
    <label for={id}>{text}</label>
    <input type="password" class="form-control password" id={id} placeholder={text} bind:value={value} on:change={validate}>
    {#if !isValid}
        <span class="errorMessage">{validationMessage}</span>
    {/if}
</div>